import { NgModule } from '@angular/core';
import { ResponsiveTableComponent } from './responsive-table.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { DataTablesModule } from 'angular-datatables';
import { CommonModule } from '@angular/common';
import { ElementBlockerModule } from '../element-blocker/element-blocker.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    DataTablesModule,
    ElementBlockerModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    TranslateModule,
  ],
  declarations: [ResponsiveTableComponent],
  providers: [],
  exports: [ResponsiveTableComponent],
})
export class ResponsiveTableModule {}
